/* import __COLOCATED_TEMPLATE__ from './basic-section.hbs'; */
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './basic-section.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsContactInfoBasicSection extends Component {
  @service session;
}
